"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import Image from "next/image"
import { Desktop } from "ui"
import { extractProperty, extractPropertyMediaItems, getUmbracoMediaUrl } from "utils"
import Breadcrumbs from "../DynamicForm/Breadcrumbs"
import ProductDetails from "./ProductDetails"

const StyledContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    width: calc(1040px + (100% - 1040px) / 2);
    max-width: 100%;
    margin-left: auto;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    width: calc(1280px + (100% - 1280px) / 2);
    margin-left: auto;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.values.xl}px) {
    width: 1280px;
    margin: auto;
    padding: 0px;
  }
`

const StyledContentContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    display: flex;
    justify-content: space-between;
    gap: 60px;
  }
`

const StyledDetailsSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
  padding: 32px 0 0;
  width: 100vw;
  ${(props) => props.theme.breakpoints.up("md")} {
    overflow-x: hidden;
    width: fit-content;
    gap: 24px;
  }
`

export const StyledProductImageWrapper = styled.div`
  width: 100vw;
  max-width: 100%;
  height: 343px;
  margin-top: 16px;
  position: relative;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 560px;
    height: 705px;
    margin-top: 0;
    position: sticky;
    top: 98px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.values.xl}px) {
    width: 680px;
  }
`

function ProductMainContent({
  locale,
  pageData,
  data,
  productCategories,
}: {
  locale: "he" | "en"
  pageData: any
  data: any
  productCategories?: any
}) {
  const productName = extractProperty(pageData, "productName")
  const productImage = extractPropertyMediaItems(pageData, "image")
  return (
    <>
      <StyledContainer>
        <StyledContentContainer>
          <StyledDetailsSide>
            <Box>
              <Breadcrumbs data={data} locale={locale} />
            </Box>
            <ProductDetails
              pageData={pageData}
              locale={locale}
              productCategories={productCategories}
            />
          </StyledDetailsSide>
          <Desktop
            sx={{
              maxWidth: {
                xs: "50%",
                xl: "unset",
              },
            }}
          >
            <StyledProductImageWrapper>
              {productImage?.[0] && (
                <Image
                  src={getUmbracoMediaUrl(productImage?.[0])}
                  alt={`${productName} Image`}
                  fill
                  style={{ objectFit: "contain" }}
                  priority
                />
              )}
            </StyledProductImageWrapper>
          </Desktop>
        </StyledContentContainer>
      </StyledContainer>
    </>
  )
}
export default ProductMainContent
